import { render } from "./ModalsContainer.vue?vue&type=template&id=1e460a07&ts=true"
import script from "./ModalsContainer.vue?vue&type=script&lang=ts"
export * from "./ModalsContainer.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__